import {Component, Input, OnInit} from '@angular/core';
import Article from 'src/app/models/Article';
import ArticleGroup from 'src/app/models/ArticleGroup';
import {OrderStatus} from 'src/app/models/OrderStatus';

@Component({
	selector: 'app-order-item-articlegroup-draw',
	templateUrl: './order-item-articlegroup-draw.component.html',
	styleUrls: ['./order-item-articlegroup-draw.component.scss']
})
export class OrderItemArticlegroupDrawComponent implements OnInit {
	@Input() articleGroup: ArticleGroup;
	@Input() orderStatus: OrderStatus | null;

	public orderStatusEnum = OrderStatus;

	detailsVisible = false;
	detailsPosition = {x: 0, y: 0};

	constructor() {}

	ngOnInit() {}

	// hasInactiveArticles(article?: Article) {
	// 	if (article) {
	// 		return article.isInactiveArticle;
	// 	}
	// 	return false;
	// }

	showDetails(event: MouseEvent, article: Article) {
		if (!article.isInactiveArticle) {
			return;
		}

		const target = event.target as HTMLElement;
		const rect = target.getBoundingClientRect();

		this.detailsPosition = {
			x: rect.left + rect.width / 2,
			y: rect.top - 10
		};

		this.detailsVisible = true;
	}

	hideDetails() {
		this.detailsVisible = false;
	}
}
